import React, { useState, useEffect, useRef } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { Row, Col, Button } from "../ui/ot";
import styled from "styled-components";
import { useWebsiteBasicInformation } from "../official_web/controller/WebsiteBasicInformationController";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import ScrollButton from "../../theme/components/scroll_button"

const levelStyles = [
    {
        backgroundColor: "#29166f",
        color: "#ffffff",
        hoverBackgroundColor: "#4c2497",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    {
        backgroundColor: "#f1e6ff",
        color: "#29166f",
        hoverBackgroundColor: "#e1c4f5",
        boxShadow: "none",
    },
    {
        backgroundColor: "#ffffff",
        color: "#29166f",
        hoverBackgroundColor: "#f3f4f6",
        boxShadow: "none",
    },
];

const NavBar = ({ menuData = [] }) => {
    const NavItem = ({ menu = {}, level = -1 }) => {
        const [isOpen, setIsOpen] = useState(false);
        const hasChildren = Array.isArray(menu.children) && menu.children.length > 0;
        const styles = levelStyles[Math.min(level, 2)];

        const toggleOpen = () => setIsOpen((prev) => !prev);

        return (
            <div
                style={{
                    position: "relative",
                    marginBottom: "4px", // 選單項目間的間距
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        fontWeight: level === -1 ? "bold" : "normal",
                        padding: "8px 16px",
                        fontSize: level === -1 ? "1rem" : "0.875rem", // 頂層較大，子層較小
                        textDecoration: "none",
                        backgroundColor: level > -1 ? styles.backgroundColor : "#ffffff",
                        color: level > -1 && styles.color,
                        borderRadius: "4px",
                        boxShadow: level > -1 && styles.boxShadow, // 子層添加陰影
                    }}
                >
                    {menu.path_check === 0
                        ?
                        <Link
                            to={`${menu.key || "#"}`}
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                                flex: "1",
                            }}
                        >
                            {menu.label}
                        </Link>
                        : <a href={menu.key} style={{ textDecoration: 'none' }} target="_blank">
                            {menu.label}

                        </a>
                    }

                    {hasChildren && (
                        <button
                            onClick={toggleOpen}
                            style={{
                                background: "none",
                                border: "none",
                                padding: "0",
                                cursor: "pointer",
                                color: level > -1 && styles.color,
                                // color: level > -1 ? "#ffffff" : "#4b5563",
                                fontSize: "1rem",
                                transform: isOpen ? "rotate(180deg)" : "rotate(0)",
                                transition: "transform 0.2s ease",
                                marginLeft: "0.2rem"
                            }}
                        >
                            ▼
                        </button>
                    )}
                </div>
                {hasChildren && isOpen && (
                    <div
                        style={{
                            // 第一層使用絕對定位，避免影響 NavBar 高度
                            position: level === -1 ? "absolute" : "relative", // 第一層絕對定位，其他層級則保持正常
                            top: "100%",
                            left: 0,
                            marginTop: "4px",
                            borderLeft: level > -1 ? "2px solid #e5e7eb" : "none", // 添加左側邊框指示層級
                            paddingLeft: "8px",
                            backgroundColor: "#ffffff",
                            zIndex: "100", // 確保子選單顯示在其他元素之上
                        }}
                    >
                        {menu.children.map((child, index) => (
                            <NavItem key={index} menu={child} level={level + 1} />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <nav
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "24px",
                backgroundColor: "#ffffff",
                padding: "16px 32px",
                borderBottom: "2px solid #e5e7eb",
                position: "relative",
                maxWidth: "100%", // 限制在螢幕範圍內
                boxSizing: "border-box",
            }}
        >
            {menuData.map((menu, i) => (
                <NavItem key={i} menu={menu} />
            ))}
        </nav>
    );
};

const NavBarMobile = ({ menuData = [] }) => {
    const NavItem = ({ menu = {}, level = 0 }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const hasChildren = Array.isArray(menu.children) && menu.children.length > 0;

        const levelStyles = [
            {
                backgroundColor: "#29166f",
                color: "#ffffff",
                hoverBackgroundColor: "#4c2497",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            },
            {
                backgroundColor: "#f1e6ff",
                color: "#29166f",
                hoverBackgroundColor: "#e1c4f5",
                boxShadow: "none",
            },
            {
                backgroundColor: "#ffffff",
                color: "#29166f",
                hoverBackgroundColor: "#f3f4f6",
                boxShadow: "none",
            },
        ];

        const styles = levelStyles[Math.min(level, 2)];

        const toggleExpand = () => setIsExpanded(!isExpanded);

        return (
            <div
                style={{
                    marginBottom: "0.5rem",
                    transition: "margin-left 0.3s ease",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: styles.color,
                        fontWeight: "bold",
                        fontSize: "1rem",
                        padding: "8px 16px",
                        textDecoration: "none",
                        backgroundColor: styles.backgroundColor,
                        borderRadius: "8px",
                        boxShadow: styles.boxShadow,
                        transition: "background-color 0.3s ease, color 0.3s ease",
                        cursor: hasChildren ? "pointer" : "default",
                    }}
                >
                    <div>
                        {menu.path_check === 0 ? (
                            <Link
                                to={`${menu.key || "#"}`}
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                {menu.label}
                            </Link>
                        ) : (
                            <a
                                href={menu.key}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {menu.label}
                            </a>
                        )}
                    </div>
                    {hasChildren && (
                        <div
                            onClick={toggleExpand}
                            style={{
                                marginLeft: "8px",
                                cursor: "pointer",
                                userSelect: "none",
                            }}
                        >
                            {isExpanded ? "▲" : "▼"}
                        </div>
                    )}
                </div>
                {hasChildren && isExpanded && (
                    <div
                        style={{
                            marginTop: "8px",
                            paddingLeft: "16px",
                            borderLeft: "2px solid #e5e7eb",
                        }}
                    >
                        {menu.children.map((child, index) => (
                            <NavItem key={index} menu={child} level={level + 1} />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div
            style={{
                padding: "16px",
                maxHeight: "90vh",
                overflowY: "auto",
                scrollbarWidth: "thin",
            }}
        >
            {menuData?.map((menu, i) => (
                <div key={i}>
                    <NavItem menu={menu} />
                </div>
            ))}
        </div>
    );
};



const Header = ({ information, menuData = [], imageFileData = [] }) => {

    const renderLogoImage = (imageFileDatas) => {
        let LogoImageFileData = imageFileDatas?.find(ele => ele?.title === "Logo");
        let classifyStructureTypeFileData = LogoImageFileData?.classify_structure_type_file_data || [];
        if (classifyStructureTypeFileData.length > 0) {
            return classifyStructureTypeFileData.map((file) => {
                return (
                    <a href="/officialweb/frontend" key={file.file_id}>
                        <img
                            style={{
                                // width: "100%",
                                // height: window.innerWidth > 768 ? "3.6vw" : "8vw"
                            }}
                            src={file?.file_url}
                            alt="Logo"
                        />
                    </a>
                );
            });
        } else {
            let nameLanguageData = information?.name_language_data || [];
            let showNameData = nameLanguageData.find((ele) => ele?.language_culture_code === "zh-tw");
            let showName = showNameData?.language_culture_value;
            return showName || "Logo";
        }
    };

    const [openMenu, setOpenMenu] = useState(false);

    return (
        <>
            <div
                className="p-1 lg:px-8 xl-16 bg-white"
                style={{
                    position: "sticky",
                    top: "0",
                    zIndex: "999",
                    width: "100vw", // 限制在螢幕範圍內
                }}
            >
                <div className="hidden lg:block">
                    <Row
                        justify="space-between"
                        align="middle"
                        wrap="true"
                        gutter={[0, 14]}
                        style={{
                            maxWidth: "100vw", // 限制Row最大寬度
                            // overflow: "hidden", // 確保內容不超出範圍
                        }}
                    >
                        {/* Logo */}
                        <Col
                            className="flex justify-center md:justify-start"
                            style={{
                                maxWidth: "calc(100vw / 5)", // 可選：限制Logo部分最大寬度
                            }}
                        >
                            {renderLogoImage(imageFileData)}
                        </Col>

                        {/* NavBar */}
                        <Col
                            style={{
                                maxWidth: "calc(100vw / 4*3)", // 確保NavBar寬度也不超過螢幕
                            }}>
                            <NavBar menuData={menuData} />
                        </Col>
                    </Row>
                </div>
                <div className="block lg:hidden">
                    <Row
                        justify="space-between"
                        align="middle"
                        wrap="true"
                        gutter={[0, 14]}
                    >
                        {/* Logo */}
                        <Col
                            // xs={8}
                            // sm={8}
                            // md={6}
                            // lg={0}
                            // xl={0}
                            className="flex justify-center md:justify-start"
                        >
                            {renderLogoImage(imageFileData)}
                        </Col>
                        <Col>
                            <div className=" text-end mr-4 ">
                                <span
                                    className=" cursor-pointer"
                                    onClick={() => { setOpenMenu(pre => !pre) }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                    </svg>
                                </span>
                            </div>
                        </Col>
                    </Row>

                    {/* 背景模糊遮罩 */}
                    {openMenu && (
                        <div
                            className="fixed inset-0 bg-black/30 backdrop-blur-sm z-10 transition duration-500"
                            onClick={() => setOpenMenu(false)}
                        ></div>
                    )}

                    <div
                        className={`p-4  fixed top-0 right-0 w-[300px] max-w-[90%] h-screen bg-white overflow-hidden transform transition-transform duration-300 ease-in-out z-20 ${openMenu ? "translate-x-0" : "translate-x-full"
                            }`}
                    >
                        <Row justify={'end'} >
                            <span
                                className=" cursor-pointer text-end "
                                onClick={() => { setOpenMenu(pre => !pre) }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </span>
                        </Row>
                        <div className="mt-4">
                            {/* {menuData?.map((menu, i) => (
                                <div key={i}>
                                    <div className=" text-blue-500 p-3 fw-bolder  text-lg">
                                        <Link to={`${menu?.key}`}>{menu?.label}</Link>
                                    </div>
                                    <hr />
                                </div>
                            ))} */}
                            <NavBarMobile menuData={menuData} />

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
const FooterContainer = styled.footer`
  background-color: #29166f;
  color: white;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 14px;
`;

const CampusInfo = styled.div`
  flex: 1;
  margin: 10px;
  min-width: 250px;

  h3 {
    font-size: 16px;
    margin-bottom: 10px;
    color: #fff;
  }

  p {
    margin: 5px 0;
  }

  iframe {
    width: 100%;
    height: 200px;
    border: none;
    margin-top: 10px;
  }
`;

const SocialLinks = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 10px;
  min-width: 250px;

  h3 {
    font-size: 16px;
    margin-bottom: 10px;
    color: #fff;
  }

  .icons {
    display: flex;
    gap: 15px;
    margin: 10px 0;

    a {
      color: white;
      font-size: 24px;
      transition: transform 0.2s;
    }

    a:hover {
      transform: scale(1.1);
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;

    button {
      background-color: white;
      color: rgb(125 84 39);
      border: none;
      padding: 10px 15px;
      font-size: 14px;
      cursor: pointer;
      border-radius: 5px;
      transition: background-color 0.3s, color 0.3s;
    }

    button:hover {
      background-color: rgb(125 84 39);
      color: white;
    }
  }
`;

const VisitorCounter = styled.div`
  flex: 1;
  margin: 10px;
  text-align: center;
  color: white;

  h3 {
    font-size: 16px;
    margin-bottom: 10px;
    color: #fff;
  }

  p {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }
`;
const Footer = ({ information, imageFileData = [] }) => {

    const navigate = useNavigate();

    const handleContactUs = () => {
        navigate('/officialweb/frontend/appointment');
    };

    const handleReportIssue = () => {
        navigate('/officialweb/frontend/question_and_answer');
    };

    const renderLogoImage = (imageFileDatas) => {
        let LogoImageFileData = imageFileDatas?.find(ele => ele?.title === "頁尾Logo");
        let classifyStructureTypeFileData = LogoImageFileData?.classify_structure_type_file_data || [];
        if (classifyStructureTypeFileData.length > 0) {
            return classifyStructureTypeFileData.map((file) => {
                return (
                    <img
                        key={file.file_id}
                        style={{ width: "auto", height: "50px" }}
                        src={file?.file_url}
                        alt="Footer Logo"
                    />
                );
            });
        } else {
            let nameLanguageData = information?.name_language_data || [];
            let showNameData = nameLanguageData.find((ele) => ele?.language_culture_code === "zh-tw");
            let showName = showNameData?.language_culture_value;
            return showName || "Logo";
        }
    };

    return (
        <FooterContainer>
            {/* 校區資訊 */}
            <CampusInfo>
                {/* <h3>介壽校區</h3> */}
                <p><strong>地址：</strong>{information?.address}</p>
                <p><strong>電話：</strong>{information?.phone}</p>
                <p><strong>電子郵件：</strong> {information?.email}</p>
                <div
                    dangerouslySetInnerHTML={{
                        __html: information?.google_map_iframe?.replace(
                            `width="600" height="450"`,
                            `width="100%" height="100%"`
                        ),
                    }}
                />
            </CampusInfo>

            {/* 校區二資訊 */}
            {/* <CampusInfo>
                <h3>巨輪校區</h3>
                <p><strong>地址：</strong>高雄市岡山區巨輪路1號</p>
                <p><strong>電話：</strong>07-6267542</p>
                <p><strong>電子郵件：</strong> {information?.email}</p>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.1082379444497!2d120.27990299999999!3d22.7984529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0c2167cae301%3A0xb92d99b38aee674d!2z56m66LuN6Iiq56m65oqA6KGT5a246Zmi5beo6Lyq5qCh5Y2A!5e0!3m2!1szh-TW!2stw!4v1735274491311!5m2!1szh-TW!2stw"
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </CampusInfo> */}

            {/* 社群連結與按鈕 */}
            <SocialLinks>
                <h3>聯繫我們</h3>
                <div className="icons">
                    {(information?.information_community_data || []).map(
                        (communityDataItem, communityDataIndex) => (
                            <a key={communityDataIndex} href={communityDataItem?.link} target="_blank" rel="noopener noreferrer">
                                <img
                                    style={{ height: "30px" }}
                                    src={communityDataItem?.icon}
                                    alt={`${communityDataItem?.link} Icon`}
                                />
                            </a>
                        )
                    )}
                </div>
                <div className="buttons">
                    <Button onClick={handleContactUs}>
                        <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '0.1rem' }} /> 聯絡我們
                    </Button>
                    <Button onClick={handleReportIssue}>
                        <FontAwesomeIcon icon={faQuestionCircle} style={{ marginRight: '0.1rem' }} /> 常見問題
                    </Button>
                </div>
                <VisitorCounter>
                    <h3>網站瀏覽人次</h3>
                    <p>{information?.view_count}</p>
                </VisitorCounter>
            </SocialLinks>

            {/* 瀏覽人次統計 */}
        </FooterContainer>
    );
};

const Content = ({ children }) => {
    return (
        <div style={{
            maxWidth: "100vw", // 限制Row最大寬度
            overflow: "hidden", // 確保內容不超出範圍
        }}>
            {children}
        </div>
    );
};

const ComponentLayout = ({
    menuData = [
        {
            label: "國科會相關計畫",
            key: "/officialweb/frontend/442",
            type: "primary",
            path_check: 0,
            children: [
                {
                    label: "aaaaaaaaaa",
                    key: "/officialweb/frontend/295/443",
                    path_check: 0,
                    children: [
                        {
                            label: "wweedxweddc",
                            key: "/officialweb/frontend/295/443/446",
                            path_check: 0,
                            children: [
                                {
                                    label: "asdfghjkjhbvcxz",
                                    key: "/officialweb/frontend/295/443/446/447",
                                    path_check: 0,
                                    children: [],
                                },
                            ],
                        },
                    ],
                },
                {
                    label: "tgbhnjkloiuyhg",
                    key: "/officialweb/frontend/295/444",
                    path_check: 0,
                    children: [
                        {
                            label: "qwertyuiolkmnbvcx",
                            key: "/officialweb/frontend/295/444/445",
                            path_check: 0,
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            label: "本計畫各類好聞",
            key: "/officialweb/frontend/442",
            type: "primary",
            path_check: 1,
            children: [],
        },
        {
            label: "國際資訊",
            type: "primary",
            key: "/officialweb/frontend/442",
            path_check: 0,
            children: [],
        },
        {
            label: "統計資料庫",
            key: "/officialweb/frontend/449",
            type: "primary",
            path_check: 0,
            children: [],
        },
        {
            label: "會議.活動.連結",
            key: "/officialweb/frontend/449",
            type: "primary",
            path_check: 0,
            children: [],
        },
        {
            label: "關於我們",
            key: "/officialweb/frontend/449",
            type: "secondary",
            path_check: 0,
            children: [],
        },
        {
            label: "著作權聲明",
            key: "/officialweb/frontend/449",
            type: "secondary",
            path_check: 0,
            children: [],
        },
    ],
    defaultWebsiteBasicInformationData = [
        {
            information_id: 2,
            name: "primary",
            phone: "07-7172930",
            address: "802高雄市苓雅區和平一路116號",
            email: "tf@mail.nknu.edu.tw",
            contact_person: "cdcdc",
            google_map_iframe: ``,
            view_count: 410,
            information_community_data: [
            ],
            name_language_data: [
                {
                    language_manage_id: 1269,
                    language_culture_code: "zh-tw",
                    language_culture_name: "繁體中文",
                    language_culture_value: "Copyright © 2021 國科會補助「性別化創新的應用與推廣」",
                },
                {
                    language_manage_id: 1270,
                    language_culture_code: "en",
                    language_culture_name: "英語",
                    language_culture_value: "Gender in Science & Technology. All Rights Reserved",
                },
            ],
            classify_structure_type_information_data: [
            ],
            classify_structure_type_data: [
                {
                    classify_structure_type_id: 4095,
                    value: 4095,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "頁尾Logo",
                    title: "頁尾Logo",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48112,
                            file_id: 4391,
                            file_url:
                                "blob:http://localhost:3000/b0f605b1-2fb6-4c13-861a-2e7f1f2b798f",
                        },
                    ],
                    key: 1,
                    depth: 1,
                },
                {
                    classify_structure_type_id: 4096,
                    value: 4096,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "Logo",
                    title: "Logo",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48113,
                            file_id: 4388,
                            file_url:
                                "https://taiwan-gist.nknu.edu.tw/images/logo113003.png",
                        },
                    ],
                    key: 2,
                },
                {
                    classify_structure_type_id: 4097,
                    value: 4097,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "頁底圖片",
                    title: "頁底圖片",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48114,
                            file_id: 4390,
                            file_url:
                                "https://taiwan-gist.nknu.edu.tw/images/logo113003.png",
                        },
                    ],
                    key: 3,
                    depth: 1,
                },
            ],
            key: 1,
            information_staff_data: [],
        },
    ],
}) => {

    let WebsiteBasicInformationDataFirst = defaultWebsiteBasicInformationData?.find(_ => true);

    const navigate = useNavigate();

    const [information, setInformation] = useState(null);
    const [imageFile, setImageFile] = useState([]);
    const firstRender = useRef(true);

    const get_picture = (temp) => {
        (temp || []).forEach((element) => {
            const fileDataArray = element.classify_structure_type_file_data || [];
            fileDataArray.forEach((fileData) => {
                if (fileData?.file_id) {
                    axios
                        .get("/media/api/file/upload", {
                            responseType: "blob",
                            params: {
                                file_id: fileData?.file_id,
                            },
                        })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg", // 如果是 SVG, 這裡可以改成 image/svg+xml
                            });
                            const dataurl = URL.createObjectURL(blob_);

                            setImageFile((pre) => {
                                return pre.map((element) => {
                                    if (element.classify_structure_type_file_data) {
                                        element.classify_structure_type_file_data = element.classify_structure_type_file_data.map((file) => {
                                            if (parseInt(fileData?.file_id) === parseInt(file?.file_id)) {
                                                return {
                                                    ...file,
                                                    file_url: dataurl,
                                                };
                                            } else {
                                                return file;
                                            }
                                        });
                                    }
                                    return element;
                                });
                            });
                        })
                        .catch((error) => {
                            console.error(`Error fetching image for file_id ${fileData?.file_id}:`, error);
                        });
                }
            });
        });
    };

    const {
        WebsiteBasicInformationData,
        getWebsiteBasicInformationData,
        patchWebsiteBasicInformationClickData,
    } = useWebsiteBasicInformation({});

    useEffect(() => {
        let WebsiteBasicInformationDataFirst = WebsiteBasicInformationData?.find(_ => true);
        let classifyStructureTypeData = WebsiteBasicInformationDataFirst?.classify_structure_type_data || [];
        setImageFile(classifyStructureTypeData);
        setInformation(WebsiteBasicInformationDataFirst);
    }, [WebsiteBasicInformationData]);

    useEffect(() => {
        getWebsiteBasicInformationData();
        patchWebsiteBasicInformationClickData();
    }, []);

    useEffect(() => {
        if (firstRender.current && imageFile.length > 0) {
            get_picture(imageFile);
            firstRender.current = false;
        }
    }, [imageFile]);

    return (
        <>
            <Header
                information={information}
                menuData={menuData}
                imageFileData={imageFile}
            />
            <Content>
                <Row gutter={[0, 8]}
                    style={{
                        backgroundColor: "#f3fcffdb",
                    }}
                >
                    <Col span={24}>
                        <Outlet />
                    </Col>
                    <Col span={24}>
                    </Col>
                </Row>
            </Content>
            <ScrollButton color={'#000000'}></ScrollButton>

            <Footer information={information}
                imageFileData={imageFile}
            />
        </>
    );
};

export default ComponentLayout;
